import { environment } from '../../environments/environment';

export const BANNER = {
  alt: 'MilkHouse — оптова доставка продуктів',
  width: 1600,
  height: 480,
  url: [
    'https://images.ctfassets.net',
    environment.contentful.spaceId,
    '3irkdhvx2lkFkFmOb5Zu0c',
    '892fc3b2ded81044ba8aeebfecb8fe01',
    'home-banner.png',
  ].join('/'),
};
